/**
 * Primary navigation — fixed floating header + mobile drawer.
 */

export function initNavigation() {
   initDrawer();
   initSubmenus();
   initSubmenuOverlay();
   initHeaderScroll();
}

// ── Mobile drawer ────────────────────────────────────────────────────────────

function initDrawer() {
   var toggle = document.querySelector('.flip-nav__toggle');
   var close = document.querySelector('.flip-drawer__close');
   var drawer = document.getElementById('flip-nav-drawer');
   var overlay = document.getElementById('flip-nav-overlay');
   if (!drawer) return;

   function setOpen(open) {
      drawer.classList.toggle('is-open', open);
      if (overlay) overlay.classList.toggle('is-open', open);
      if (toggle) {
         toggle.setAttribute('aria-expanded', String(open));
         toggle.setAttribute('aria-label',
            open ? (toggle.dataset.labelClose || 'Close navigation menu')
               : (toggle.dataset.labelOpen || 'Open navigation menu'));
      }
      drawer.inert = !open;
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.classList.toggle('nav-open', open);

      if (open) {
         requestAnimationFrame(function () {
            var el = drawer.querySelector('a, button');
            if (el) el.focus();
         });
      } else if (toggle) {
         toggle.focus();
      }
   }

   if (toggle) toggle.addEventListener('click', function () {
      setOpen(!drawer.classList.contains('is-open'));
   });
   if (close) close.addEventListener('click', function () { setOpen(false); });
   if (overlay) overlay.addEventListener('click', function () { setOpen(false); });

   document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false);
   });
}

// ── Level-2 submenus (desktop dropdown + mobile accordion) ──────────────────
//
// Hover on desktop is handled purely in CSS. This click handler is the
// keyboard/touch fallback and drives the mobile accordion height.

function initSubmenus() {
   document.querySelectorAll('.flip-nav__toggle-sub').forEach(function (btn) {
      var submenu = btn.nextElementSibling;
      if (!submenu || !submenu.classList.contains('flip-nav__submenu')) return;

      btn.addEventListener('click', function () {
         var open = btn.getAttribute('aria-expanded') !== 'true';
         btn.setAttribute('aria-expanded', String(open));
         submenu.style.maxHeight = open ? submenu.scrollHeight + 'px' : '0px';
      });
   });

   document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = document.querySelector('.flip-nav__toggle-sub[aria-expanded="true"]');
      if (!open) return;
      open.setAttribute('aria-expanded', 'false');
      var submenu = open.nextElementSibling;
      if (submenu) submenu.style.maxHeight = '0px';
      open.focus();
   });
}

// ── Desktop submenu overlay ──────────────────────────────────────────────────
//
// Dims the page behind an open dropdown. Follows hover and keyboard focus;
// the CSS :hover/:focus-within rules already show the dropdown itself.

function initSubmenuOverlay() {
   var overlay = document.getElementById('flip-nav__submenu-overlay');
   var items = document.querySelectorAll('.flip-nav__list .flip-nav__item--has-children');
   if (!overlay || !items.length) return;

   function setOpen(open) {
      overlay.classList.toggle('is-open', open);
   }

   items.forEach(function (item) {
      item.addEventListener('mouseenter', function () { setOpen(true); });
      item.addEventListener('mouseleave', function () { setOpen(false); });
      item.addEventListener('focusin', function () { setOpen(true); });
      item.addEventListener('focusout', function (e) {
         if (!item.contains(e.relatedTarget)) setOpen(false);
      });
   });
}

// ── Header show/hide on scroll direction ─────────────────────────────────────
//
// The header stays fixed but slides out of view on scroll-down and slides
// back in on scroll-up. Always visible near the top of the page.

function initHeaderScroll() {
   var header = document.getElementById('flip-header');
   if (!header) return;

   var lastY = window.scrollY;
   var ticking = false;
   var revealThreshold = header.offsetHeight;

   function update() {
      var currentY = window.scrollY;

      if (!document.body.classList.contains('nav-open')) {
         if (currentY <= revealThreshold) {
            header.classList.remove('flip-header--hidden');
         } else if (currentY > lastY) {
            header.classList.add('flip-header--hidden');
         } else if (currentY < lastY) {
            header.classList.remove('flip-header--hidden');
         }
      }

      lastY = currentY;
      ticking = false;
   }

   window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
   }, { passive: true });
}
